// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__1_JFx","nodata":"topTable_nodata__J2W7w"};